import React, { useState } from 'react';

/**
 * Znak Triglav savjetovanja.
 *
 * Dva izreza istog logotipa:
 *   /triglav-logo.png — puni sklop s natpisom "Triglav savjetovanje d.o.o.",
 *                       ide na prijavu gdje je dovoljno velik da se čita;
 *   /triglav-znak.png — bez podnaslova, ide u traku. U traci od 52 px se
 *                       podnaslov ionako nije mogao pročitati, pa naziv firme
 *                       tamo stoji kao tekst pored znaka (vidi Navbar).
 *
 * Logo stoji na bijeloj podlozi jer je natpis crn — na tamnoplavoj traci bi
 * se izgubio.
 */
const Logo: React.FC<{ variant?: 'nav' | 'login' }> = ({ variant = 'nav' }) => {
  const [nemaSlike, setNemaSlike] = useState(false);
  const nav = variant === 'nav';

  if (nemaSlike) {
    // Ako slika ikad nestane, ime firme mora ostati ispisano.
    return (
      <span style={nav ? s.rijecNav : s.rijecLogin}>
        TRIGLAV<span style={nav ? s.tankiNav : s.tankiLogin}>SAVJETOVANJE</span>
      </span>
    );
  }

  const img = (
    <img
      src={nav ? '/triglav-znak.png' : '/triglav-logo.png'}
      alt="Triglav savjetovanje d.o.o."
      onError={() => setNemaSlike(true)}
      style={nav ? s.imgNav : s.imgLogin}
    />
  );

  return nav ? <span style={s.plocica}>{img}</span> : img;
};

const s: Record<string, React.CSSProperties> = {
  plocica: {
    display: 'inline-flex', alignItems: 'center',
    backgroundColor: '#fff', borderRadius: '5px',
    padding: '4px 9px', lineHeight: 0,
  },
  imgNav: { height: '26px', width: 'auto', display: 'block' },
  imgLogin: { height: '66px', width: 'auto', display: 'block', margin: '0 auto 1.4rem' },

  rijecNav: {
    display: 'inline-flex', alignItems: 'baseline', gap: '6px',
    fontWeight: 800, fontSize: '0.95rem', letterSpacing: '0.06em', color: '#fff',
  },
  tankiNav: { fontWeight: 400, fontSize: '0.72rem', letterSpacing: '0.14em', opacity: 0.75 },
  rijecLogin: {
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px',
    marginBottom: '1.25rem',
    fontWeight: 800, fontSize: '1.45rem', letterSpacing: '0.07em', color: '#1e3a5f',
  },
  tankiLogin: { fontWeight: 400, fontSize: '0.8rem', letterSpacing: '0.2em', color: '#64748b' },
};

export default Logo;
